import React from "react"
import * as layouts from "layouts"
import * as api from "brandguard/api"
import * as predictions from "brandguard/predictions"
import * as bgscores from "brandguard/display/scores"
import * as typography from "typography"

interface VersionItem {
	media?: { id: string; created_at: string }
	event?: { id: string; approved: api.Prediction; confidence: number }
}

interface VersionHistoryProps extends layouts.containers.FlexProps {
	versions: VersionItem[]
	current: string
	onVersionClick(version: VersionItem): void
}

function formatDate(iso: string): string {
	if (!iso) return ""
	const d = new Date(iso)
	if (isNaN(d.getTime())) return ""
	return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
}

export function VersionHistory(props: VersionHistoryProps): JSX.Element {
	const { versions, current, onVersionClick, ...rest } = props
	return (
		<bgscores.layouts.accordion.Container title="Version History" {...rest}>
			<layouts.containers.flex flexDirection="column" width="100%">
				{versions.map((v, idx) => {
					const isCurrent = v.media?.id === current
					return (
						<layouts.containers.flex
							key={v.media?.id || idx}
							flexDirection="row"
							alignItems="center"
							p="8px 12px"
							borderBottom={idx < versions.length - 1 ? layouts.theme.borders.grey.dark50alpha : "none"}
							background={isCurrent ? layouts.theme.backgrounds.bluealpha5 : "transparent"}
							cursor={isCurrent ? "default" : "pointer"}
							onClick={() => { if (!isCurrent) onVersionClick(v) }}
						>
							<typography.h5
								fontWeight={isCurrent ? "700" : "400"}
								fontSize="13px"
								color={layouts.theme.colors.grey.dark50}
								minWidth="30px"
							>
								V{idx + 1}
							</typography.h5>
							<layouts.containers.flex flex="1" flexDirection="column" px="8px">
								<typography.h5 fontSize="12px" color={layouts.theme.colors.grey.dark50}>
									{formatDate(v.media?.created_at || "")}
								</typography.h5>
							</layouts.containers.flex>
							<typography.h5
								fontSize="12px"
								fontWeight="600"
								color={predictions.color(v.event?.approved)}
							>
								{predictions.string(v.event?.approved)}
							</typography.h5>
						</layouts.containers.flex>
					)
				})}
			</layouts.containers.flex>
		</bgscores.layouts.accordion.Container>
	)
}
